import { render, staticRenderFns } from "./EditFormShellEditor.vue?vue&type=template&id=7fdab138&"
import script from "./EditFormShellEditor.vue?vue&type=script&lang=js&"
export * from "./EditFormShellEditor.vue?vue&type=script&lang=js&"
import style0 from "./EditFormShellEditor.vue?vue&type=style&index=0&id=7fdab138&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports